import { render } from "./TestPrepare.vue?vue&type=template&id=954ff18c&scoped=true"
import script from "./TestPrepare.vue?vue&type=script&lang=js"
export * from "./TestPrepare.vue?vue&type=script&lang=js"

import "./TestPrepare.vue?vue&type=style&index=0&id=954ff18c&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-954ff18c"]])

export default __exports__